






import { Component, Vue } from 'vue-property-decorator';
import RegistrationHeaderTab from './RegistrationHeaderTab.vue';
import { NavigationTab } from '@/interfaces/registration/NavigationTab';
import { namespace } from 'vuex-class';
const navigation = namespace('navigation');

@Component({
  components: {
    RegistrationHeaderTab
  }
})
export default class RegistrationHeader extends Vue {
  @navigation.Getter
  public filteredNavigationTabs!: Array<NavigationTab>;
}
